import { Attr, BelongsTo, Model } from 'spraypaint';
import type User from './User';
import ApplicationRecord from './ApplicationRecord';

@Model()
class UserImportantAlert extends ApplicationRecord {
  static jsonapiType = 'user_important_alerts';

  @Attr() userId!: number;

  @Attr() content!: string;

  @Attr({ persist: false }) createdAt!: string;

  @Attr({ persist: false }) updatedAt!: string;

  @BelongsTo('users') user!: User;
}

export default UserImportantAlert;
